module.exports = __webpack_public_path__ + "static/media/warehouse_large.109d2c20.svg";